module.exports = __webpack_public_path__ + "static/media/SmartShop_3-424w.9ed130aa.png";